import { APIRequest } from '@/infra/network/APIRequest'
import { Snapsnap } from '@photocreate/snapsnap-api'
import { HTTPMethod } from '@/infra/network/types'

export class GetTpoints implements APIRequest<Snapsnap.TPoint.GetTpointsResponse> {
  response: Snapsnap.TPoint.GetTpointsResponse
  path = '/tpoint/points'
  method = HTTPMethod.GET
}
